/**
 * Type and helper functions to manage the geom union type
 * @module
 */
import { aabb3Init, aabb3Union } from "./aabb3";
import type { AABB3 } from "./aabb3Types";
import {
  faceAABB3,
  type BRep,
  type Extrusion,
  type Face,
  type FaceGroup,
  brepAABB3,
  facesAABB3,
  extrusionAABB3,
} from "./brep";
import { extrusionToBRep } from "./extrude";

export type Geom = BRep | Face | Extrusion | FaceGroup;

export function geomToFaces(geom: Geom): Face[] {
  switch (geom.type) {
    case "EXTRUSION":
      if (!geom.profile) {
        return [];
      }
      const brep = extrusionToBRep(geom);
      return brep.faces;
    case "FACE":
      return [geom];
    case "BREP":
      return geom.faces;
    case "FACE_GROUP":
      return geom.faces;
  }
}

export function geomAABB3(geom: Geom): AABB3 {
  switch (geom.type) {
    case "EXTRUSION":
      return extrusionAABB3(geom);
    case "FACE":
      return faceAABB3(geom);
    case "BREP":
      return brepAABB3(geom);
    case "FACE_GROUP":
      return facesAABB3(geom.faces);
  }
}

export function geomMultiAABB3(geom: Geom[]): AABB3 {
  return geom.map(geomAABB3).reduce(aabb3Union, aabb3Init());
}
